/**
 * @prop --vx-content-slide-default-width: Default width of the mobile image slide element.
*/
:host.splide__slide {
  width: var(--vx-content-slide-default-desktop-width, 20%);
}

@media screen and (max-width: 480px) {
  :host.splide__slide {
    width: var(--vx-content-slide-default-mobile-width, 100%);
  }
}
@media screen and (max-width: 768px) {
  :host.splide__slide {
    width: var(--vx-content-slide-default-tablet-portrait-width, 50%);
  }
}
@media screen and (max-width: 960px) {
  :host.splide__slide {
    width: var(--vx-content-slide-default-tablet-landscape-width, 33%);
  }
}
@media screen and (max-width: 1024px) {
  :host.splide__slide {
    width: var(--vx-content-slide-default-desktop-small-width, 25%);
  }
}